import { loadable } from '../../../utils';

export const CreateWizard = loadable(() => import('./CreateWizard'), {});
export const Edit = loadable(() => import('./Edit'), {});
export const Value = loadable(() => import('./Value'), {});
export const Validator = loadable(() => import('./Validator'), {});
